import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const RevenueChart = ({ data }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return `${date?.getMonth() + 1}/${date?.getDate()}`;
  };

  const formatCurrency = (value) => {
    return `$${value?.toFixed(2)}`;
  };

  if (!data || data?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Revenue Trend</h2>
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="TrendingUp" size={48} className="text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No revenue data available for the selected period</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Revenue Trend</h2>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis
            dataKey="date"
            tickFormatter={formatDate}
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            tickFormatter={formatCurrency}
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <Tooltip
            formatter={(value) => formatCurrency(value)}
            labelFormatter={(label) => `Date: ${label}`}
            contentStyle={{
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              borderRadius: '8px',
              color: 'var(--color-foreground)'
            }}
          />
          <Line
            type="monotone"
            dataKey="amount"
            stroke="var(--color-primary)"
            strokeWidth={2}
            dot={{ fill: 'var(--color-primary)', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueChart;